import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { validateEmail } from '../../utils/utils';
import { setLead as setLeadDispatch } from '../../redux/lead/leadSlice';

const useHook = () => {
  const dispatch = useDispatch();
  const reduxLead = useSelector((state: any) => state.lead.lead);

  const [emailSended, setEmailSended] = useState("");
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleChange = (e: string) => {
    setEmail(e);
    setIsEmailValid(validateEmail(e));
  };

  const guardaLeadEnRedux = (email: string) => {
    setTimeout(() => {
      dispatch(setLeadDispatch(email));
    }, 2000);
  };

  const send = async () => {
    setLoading(true);

    const body = {
      data: {
        email: email,
        section: "Leadbox en footer"
      }
    };

    try {
      const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/leads/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await result.json();
      if (data?.data?.id) {
        setEmailSended(email);
        setEmail("");
        setShowSnackbar(true);
        setSnackbarMessage("¡Gracias por registrarte!");
        guardaLeadEnRedux(email);
      } else {
        setShowSnackbar(true);
        setSnackbarMessage("Ocurrió un error inesperado.");
      }
    } catch (err) {
      console.log("e", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    setEmailSended(reduxLead);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    email,
    emailSended,
    isEmailValid,
    loading,
    showSnackbar,
    snackbarMessage,
    handleChange,
    send,
    setShowSnackbar,
  };
};

export default useHook;
